import {BaseUserFlow, UserFlowStep, UserFlowList} from './BaseUserFlow';
import {UserFlowType} from './UserFlowFacade';

export class OptionsAndExtrasUserFlow extends BaseUserFlow {
  protected readonly type = UserFlowType.OptionsAndExtras;

  /**
   * @inheritdoc
   */
  public setCurrentStep = (newStep: string) => {
    const steps = this.getSteps();
    this.setStep(steps.indexOf(`${newStep}` as string));

    return this;
  };

  /**
   * @inheritdoc
   */
  public configure(): UserFlowList {
    const newSteps = [
      `${this.type}.${UserFlowStep.Components}`,
      `${this.type}.${UserFlowStep.PerfectlyClear}`,
      `${this.type}.${UserFlowStep.ProjectSummary}`,
    ];

    // Reset the step.
    this.setStep(0);

    return newSteps;
  }
}
